import { useAuthToken } from '@/services/auth';
import { useAuthStore } from '@/store/auth';
import { useOrganisationStore } from '@/store/organisation';
import { apiBasePath } from '@/utils/apiBasePath';
import { Configuration, OrganisationsApi } from '@teemill/organisations';
import { computedEager, watchImmediate } from '@vueuse/core';
import { computed } from 'vue';

const client = new OrganisationsApi(
  new Configuration({
    basePath: apiBasePath(),
    accessToken: async () => useAuthToken(),
  }),
);

export const useOrganisations = () => {
  const store = useOrganisationStore();

  return {
    client,
    ready: computed(() => store.ready),
    organisation: computed(() => store.active),
    organisations: computed(() => store.organisations),
  };
};

export const useOrganisation = () => computedEager(() => useOrganisationStore().active);

export const organisation = {
  async install() {
    const authStore = useAuthStore();
    const organisationStore = useOrganisationStore();

    watchImmediate(
      () => ({
        ready: authStore.ready,
        authenticated: authStore.isAuthenticated,
      }),
      async ({ ready, authenticated }) => {
        if (!ready) {
          return;
        }

        if (!authenticated) {
          organisationStore.update([]);
        } else {
          try {
            const { organisations } = await client
              .getOrganisations()
              .then((response) => response.data);

            organisationStore.update(organisations);
          } catch (error: any) {
            switch (error.response?.status) {
              case 401:
                organisationStore.update([]);
                break;

              case 403:
                organisationStore.update([]);
                organisationStore.updateRedirect({ name: 'account.settings.2fa' });
                break;

              default:
                throw error;
            }
          }
        }
      },
    );
  },
};
